module.exports = __webpack_public_path__ + "static/media/11.16e38b37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/11.jpg
// module id = 186
// module chunks = 0